import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Info = (props: IconProps) => (
  <Icon width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17 34C26.35 34 34 26.35 34 17C34 7.65 26.35 0 17 0C7.65 0 0 7.65 0 17C0 26.35 7.65 34 17 34Z"
      fill="white"
    />
    <path d="M17.9788 14.168H15.1714C14.6165 14.168 14.1667 14.531 14.1667 14.9789V23.2737C14.1667 23.7216 14.6165 24.0846 15.1714 24.0846H17.9788C18.5336 24.0846 18.9834 23.7216 18.9834 23.2737V14.9789C18.9834 14.531 18.5336 14.168 17.9788 14.168Z" />
    <path d="M16.5751 12.75C17.9052 12.75 18.9834 11.7986 18.9834 10.625C18.9834 9.45139 17.9052 8.5 16.5751 8.5C15.245 8.5 14.1667 9.45139 14.1667 10.625C14.1667 11.7986 15.245 12.75 16.5751 12.75Z" />
  </Icon>
);
